import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { IMajorTech } from "../../models/MajorTech";
import { IPermissionProps } from "../../models/Login";
import { Table } from "./Table";
import { IPipelineStatus } from "./IPipelineStatus";
import { EmptyPipelineStatus } from "./EmptyPipelineStatus";
import { Form } from "./Form";

export interface IModel {
    open: boolean,
    singleData: IPipelineStatus
}

export const PipelineStatus = (permissions: IPermissionProps) => {

    const [modal, setModal] = useState({ singleData: EmptyPipelineStatus, open: false } as IModel);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyPipelineStatus, open: false })
    };


   

    return (
        <>
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload} open={undefined} ></Table>
            <Form  permissions={permissions} singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>
            <Toast ref={toast} />
        </>
    );
}
